module.exports = __webpack_public_path__ + "img/icon-box.f3cf8b6d.svg";